import React from 'react';

import ListResource from './ListResource.jsx';
import { env } from '~/commons/config';

const ListSchools = () => (
  <ListResource
    {...{
      searchable: true,
      api: 'api/core/schools',
      sort: { 'title.zhhk': 1 },
      actions: { remove: false },
      cols: [
        { key: 'title.zhhk', children: '名稱', sortable: true },
        { key: 'title.en', children: 'Name', sortable: true },
        {
          key: 'district',
          sortable: true,
          getter: (v) => env.districts[v].zhhk,
        },
        {
          key: 'stage',
          sortable: true,
          getter: (v) => ({
            p: 'Primary',
            s: 'Secondary',
          }[v]),
        },
      ],
    }}
  />
);

export default ListSchools;
